import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    border: `2px solid ${theme.onCardDivider.green_80}`,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(4),
    margin: theme.spacing(2, 0),
    width: '100%'
  },
  // #35739: the UW override checkbox sits between the locked toggle and the surfacing-type boxes.
  uwOverride: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  headerText: {
    fontSize: 14,
    lineHeight: '20px',
    color: theme.onCard.white,
    marginBottom: theme.spacing(2)
  },
  label: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.colorPalette.beige_60,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(2)
  },
  divider: {
    '&::before': {
      backgroundColor: theme.colorPalette.green_80
    },
    '&::after': {
      backgroundColor: theme.colorPalette.green_80
    },
    ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_60 })
  }
});

export default makeStyles(styles);
